import { Css, Palette } from "~generated/css";
import { IMAGE_NOT_FOUND_URL } from "../atoms";

export function ImagePlaceholder({
  text,
  bgColor,
  src,
  size,
}: {
  text?: string;
  bgColor?: Palette;
  src?: string;
  size?: {
    height: number;
    width: number;
  };
}) {
  return (
    <div css={Css.df.fdc.jcc.aic.w100.h100.z0.if(!!bgColor).bgColor(bgColor).else.bgLightBlue.$}>
      <img
        css={Css.hPx(size?.height ?? 56).wPx(size?.width ?? 56).objectCover.$}
        src={src ?? IMAGE_NOT_FOUND_URL}
        alt=""
      />
      {text && <p css={Css.mt1.t12.tac.gray600.$}>{text}</p>}
    </div>
  );
}
